import React from 'react';
import { ResponsiveContainer, Bar, BarChart, YAxis, XAxis, Legend, Tooltip } from 'recharts';
import { formatNumber, formatCurrency, ESTIMATE_YEARS, YEARS } from '../../../helpers';
import './index.scss';
import { getText } from '../../../texts';
import { data } from '../../../data';

interface CityChartProps {
  city: (typeof data.cities)[0];
  dataKey: string;
}

const chartMinValueGap = 0.3;
const chartMaxValueGap = 0.05;
const poulationChartBarColor = '#00b22d';
const revenueChartBarColor = '#b3b3b3';

const CityChart: React.FC<CityChartProps> = ({ city }) => {
  const chartData = city.chart_data
    .filter(({ year }) => YEARS.includes(year))
    .map((data) => ({
      year: `${ESTIMATE_YEARS.includes(data.year) ? '*' : ''}${data.year}`,
      revenue: data.total.revenue,
      population: data.total.population,
    }));

  return (
    <div className="city-chart">
      <h4>{getText('chart_title')}</h4>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={chartData}>
          <Tooltip
            formatter={(value, name, props) =>
              props.dataKey === 'revenue' ? formatCurrency(value as number) : formatNumber(value)
            }
          />
          <XAxis dataKey="year" interval="preserveStartEnd" axisLine={false} tickLine={false} tickMargin={15} />
          <YAxis
            hide={true}
            yAxisId="revenue"
            dataKey="revenue"
            domain={[
              (dataMin) => dataMin - dataMin * chartMinValueGap,
              (dataMax) => dataMax + dataMax * chartMaxValueGap,
            ]}
          />
          <YAxis
            hide={true}
            yAxisId="popupation"
            dataKey="population"
            orientation="right"
            domain={[(dataMin) => dataMin - dataMin * chartMinValueGap, (dataMax) => dataMax + dataMax]}
          />
          <Bar
            yAxisId="popupation"
            name={getText('chart_title_population')}
            type="linear"
            dataKey="population"
            fill={poulationChartBarColor}
            animationBegin={1700}
            animationDuration={1700}
          />
          <Bar
            yAxisId="revenue"
            name={getText('chart_title_revenue')}
            type="linear"
            dataKey="revenue"
            fill={revenueChartBarColor}
            animationBegin={1300}
            animationDuration={1700}
          />
          <Legend wrapperStyle={{ paddingTop: 30, paddingLeft: '2.5%' }} align="left" iconType="square" iconSize={20} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CityChart;
